export const TRIAL_INVITE_CAP = 10;

type RecipientCountInput = {
  selectedUserIds: number[];
  additionalEmails: string;
};

export const parseAdditionalEmails = (additionalEmails: string): string[] =>
  (additionalEmails || '')
    .split(',')
    .map((email) => email.trim())
    .filter((email) => email.length > 0);

export const getApprovalRecipientCount = ({
  selectedUserIds,
  additionalEmails,
}: RecipientCountInput): number => {
  const uniqueUsers = new Set(selectedUserIds);
  const uniqueEmails = new Set(parseAdditionalEmails(additionalEmails));
  return uniqueUsers.size + uniqueEmails.size;
};

export const isOverInviteCap = (count: number, cap: number): boolean =>
  count > cap;
